var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"docinfo"},[_c('nav-menu'),_c('div',{staticClass:"contact-us"},[_c('markdown-it-vue',{staticClass:"md-body",attrs:{"content":_vm.content}})],1),_c('site-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }